module.exports = "/out/21681c78751e99d0bcf70880b12247ff.svg";